import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { An, AnEditPayload } from './ani.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AniService {
    private token!: string;
    private httpOptions: any;
    private basePath = environment.interop.basePath;

    private getAniUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ani.getAni;

    private storeAnUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ani.storeAn;

    private deleteAnUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ani.deleteAn;

    private getAniActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ani.getAniActive;

    private getAniPublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ani.getAniPublic;

    private updateAnUrl =
        this.basePath + environment.interop.platform.nomenclatoare.ani.updateAni;

    private changeAnActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ani.changeStatusAniActive;

    private changeAnPublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.ani.changeStatusAniPublic;

    constructor(public http: HttpClient) { }

    addAn(an: An) {
        return this.http.post(this.storeAnUrl, an, this.httpOptions);
    }

    getAni() {
        return this.http.get(this.getAniUrl, this.httpOptions);
    }

    getAniActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getAniActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({ id: item.id, name: item.year }))
                ),
                catchError((error) => {
                    console.error('Error in get ani active: ', error);
                    return throwError(error);
                })
            );
    }

    getAniPublic() {
        return this.http.get(this.getAniPublicUrl, this.httpOptions);
    }

    updateAn(an: AnEditPayload) {
        return this.http.put(this.updateAnUrl, an, this.httpOptions);
    }

    deleteAn(id: number) {
        return this.http.delete(this.deleteAnUrl + id, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeAnActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeAnPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
